module.exports = __webpack_public_path__ + "img/Photobooth_mariage.71e0007.jpg";